<script>

import MyTitle from '@/components/my/MyTitle.vue'
import http from '@/utils/http'
import toast from '@/utils/toast'

export default {
  components: {
    MyTitle
  },
  data () {
    return {
      affiliateList: [],
      page: 1,
      loading: false,
      code: '',
      aid: '',
      type: '0',
      start: '',
      tab1: false,
      tab2: true,
      tab: 1,
      end: '',
      params: '',
      size: 20,
      invitaList: [],
      haveData: true,
      isShowOther: false,
      isShowRed: false,
      lineNum: 9,
      levels: 0,
      showAmount: '',
      pages: 0,
      skipUrl: '',
      value: '',
      isOther: false,
      isFocus: false,
      isReload: false,
    }
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '--';
      return String(dateStr).split(' ')[0].replace(/-/g, '/');
    },
    switchTab(type) {
      this.tab = type;
      if(this.tab === 1) {
        this.tab1 = true;
        this.tab2 = false;
        this.getDataListByType('0');
      } else {
        this.tab2 = true;
        this.tab1 = false;
        this.getDataListByType('1');
      }
    },
    gotoWsapp(url) {
      window.location.href = url;
      if (this.type === '0') {
        this.reportBuriedPoint('tcp_my_myinvite_all_private', '');
      } else {
        this.reportBuriedPoint('tcp_my_myinvite_active_private', '');
      }
    },
    closePage() {
      if (window.closePage) {
        window.closePage.closePage();
      }
    },
    close() {
      this.value = '';
    },
    blur() {
      this.isFocus = false;
    },
    focus() {
      this.isOther = true;
      this.isFocus = true;
    },
    change() {
      if (this.value.length == 0) {
        this.type = '0';
        this.getDataList(this.type);
      }
    },
    select() {
      if (this.value.length == 0) {
        this.isOther = false;
      } else {
        this.isOther = true;
      }
      this.type = '0';
      this.getDataList(this.type);
    },
    getMobile(mobile) {
      return mobile.substring(0, 1) + '****' + mobile.substring(mobile.length - 1, mobile.length);
    },
    scroll(e) {
      let target = e.target;
      if (!target) return;

      if (target.scrollTop + target.clientHeight >= (target.scrollHeight - 20)) {
        if (this.isReload) {
          return;
        }
        if (this.page < this.pages) {
          this.page = this.page + 1;
          this.getDataList(this.type);
        }
      }
    },
    back(value) {
      if (!value) {
        window.closePage.closePage();
      } else {
        this.value = '';
        this.isOther = false;
        this.type = '0';
        this.getDataList(this.type);
      }
    },
    setHtmlFontSize() {
      let deviceWidth = (this.params.h) / (this.params.d);
      let dom = document.getElementById("app");
      dom.style.cssText = 'width:' + (this.params.w) / (this.params.d) + 'px !important;';
      document.getElementsByTagName('html')[0].style.cssText = 'font-size:' + deviceWidth / 5.9 + 'px !important;' + 'width:' + (this.params.w) / (this.params.d) + 'px !important;';
    },
    resize() {
      this.setHtmlFontSize();
      if (window.addEventListener) {
        window.addEventListener('resize', () => {
          this.setHtmlFontSize();
        }, false);
      }
    },
    uuid() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4";
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
      s[8] = s[13] = s[18] = s[23] = "-";
      return s.join("");
    },
    reportBuriedPoint(key, value) {

    },
    getUrl(mobile) {
      return this.skipUrl.replace(`${mobile}`, "+91" + mobile);
    },
    getStatus(value) {
      var text = '';
      var color = '';
      var curDate = new Date();
      var year = curDate.getFullYear();
      var month = curDate.getMonth() + 1;
      var date = curDate.getDate();
      var preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7);
      var lastYear = preDate.getFullYear();
      var lastMonth = preDate.getMonth() + 1;
      var lastDate = preDate.getDate();
      var d = year * 10000 + month * 100 + date;
      var l = lastYear * 10000 + lastMonth * 100 + lastDate;

      if (l <= value && value <= d) {
        text = 'Active';
        color = 'green';
      } else {
        text = 'Not Active';
      }
      return { text: text, color: color };
    },
    beh(){
      let sendData = {
        code: this.appInfo.code,
        type: "3",
      };
      http.postHttp('/landscape/grade/course/behavior', sendData).then((data) => {});
    },
    getSkipUrl() {
      let params = { type: 99 };
      http.getHttp('/landscape/config/wsapp?type=99').then((data) => {
        if (data.code === 0) {
          this.skipUrl = data.data.url;
        }
      });
    },
    getUser() {
      http.getHttp('/landscape/user/getUserByCode?code=' + this.code).then((data) => {
        if (data.code === 0) {
          let res = data.data;
          this.showAmount = res.showBalance;
          this.levels = res.levels;
        }
      });
    },
    getRedDot() {
      let sendData = JSON.stringify({
        code: this.code,
        behType: '1',
      });
      http.postHttp('/landscape/vgi/getBeh', sendData).then((data) => {
        if (data.code === 0) {
          this.isShowRed = data.data != 0;
        }
      });
    },
    getDataListByType(t) {
      this.type = t;
      this.page = 1;
      this.value = '';
      this.getDataList(t);
      if (t == '0') {
        this.reportBuriedPoint('tcp_my_myinvite_all', '');
      } else {
        this.reportBuriedPoint('tcp_my_myinvite_active', '');
      }
    },
    getDataList(t) {
      if (this.isReload) return;

      this.isReload = true;
      this.type = t;
      if (t == '1') {
        this.isShowRed = false;
      }
      if (this.page == 1) {
        this.invitaList = [];
      }
      let sendData = JSON.stringify({
        code: this.code,
        type: this.type,
        page: this.page,
        size: this.size,
        value: this.value
      });

      http.postHttp('/landscape/vgi/invite', sendData).then((data) => {
        if (data.code === 0) {
          this.pages = data.data.pages;
          this.invitaList = this.invitaList.concat(data.data.records);
          if(!this.invitaList || this.invitaList.length === 0) {
            this.haveData = false;
          } else {
            this.haveData = true;
          }
          this.isShowOther = this.invitaList.length === 0;
          if (this.invitaList.length < this.lineNum) {
            var replenishLine = this.lineNum - this.invitaList.length;
            for (let index = 0; index < replenishLine; index++) {
              this.invitaList.push(null);
            }
          }
        }
        this.isReload = false;
      });
    },
    getAffiliatesList () {
      const keyword = ''
      const aid = this.$store.state.aid
      const uid = this.$store.state.uid
      const size = '15'
      const page = this.page
      const pn = this.$store.state.pn

      this.loading = true
      http.getHttp(`/landscape/customizedcustommenu/affiliates?keyword=${keyword}&aid=${aid}&uid=${uid}&size=${size}&page=${page}&pn=${pn}`).then((resp) => {
        if (resp.code !== 0) {
          toast.show(resp.msg)
          return
        }
        ++this.page
        this.affiliateList = this.affiliateList.concat(resp.page.list)
      }).finally(() => {
        this.loading = false
      })
    },

    appConfig() {
      this.appInfo = JSON.parse(localStorage.getItem('vuex'))
    },

    handleScroll (e) {
      if (this.loading) {
        return
      }
      const {
        scrollTop,
        clientHeight,
        scrollHeight
      } = e.target
      if (scrollTop + clientHeight > scrollHeight - 100) {
        this.getAffiliatesList()
      }
    }
  },
  errorCaptured(err, instance, info) {
    console.log('🔥 errorCaptured:', err)
    console.log('🔥 component:', instance)
    console.log('🔥 info:', info)
    return false
  },
  created() {
    this.appConfig()
    this.beh();
    this.value = '';
    this.code = JSON.parse(this.appInfo).code;
    this.getSkipUrl();
    this.getDataList('0');
    this.getRedDot();
    this.getUser();
    this.reportBuriedPoint('tcp_my_myinvite_all', '');
  },
  mounted () {
  }
}
</script>

<template>
  <div>
    <div class="my-affiliate-contain">
      <MyTitle class="title" title="MyReferrals"/>

      <div class="tab-wrapper">
        <div class="tab-container">
          <div :class="tab === 1 ? 'tab-item-act' : 'tab-item'" @click="switchTab(1)"><img class="btm" src="@/assets/myreferral/all.png" /></div>
          <div :class="tab === 2 ? 'tab-item-act' : 'tab-item'" @click="switchTab(2)"><img class="btm" src="@/assets/myreferral/mha.png" /></div>
        </div>
      </div>

      <div class="content">
        <div class="tab-header">
          <div class="tab-header-row">
            <p class="tab-header-cell">Name</p>
            <p class="tab-header-cell">Phone Number</p>
            <p class="tab-header-cell">Status</p>
            <p class="tab-header-cell">Invitation Time</p>
            <p class="tab-header-cell">Last Online Time</p>
            <p class="tab-header-cell">Operate</p>
          </div>
        </div>
        <div class="tab-content"  v-if="haveData" @scroll="scroll">
          <div v-for="(item,index) in invitaList" :key="index"
               :class=" index % 2 === 0 ?'tab-content-row tab-row-color':'tab-content-row'">
            <p class="tab-content-cell">
              {{ item ? item.uid : '--' }}
            </p>
            <p class="tab-content-cell">
              {{ item ? getMobile(item.mobile) : '--' }}
            </p>
            <p class="tab-content-cell">
                        <span v-if="item" :class="getStatus(item.lastRechage).color">
                            {{ getStatus(item.lastRechage).text }}
                        </span>
              <span v-else>--</span>
            </p>
            <p class="tab-content-cell">
              {{ item ? formatDate(item.invitaTime) : '--' }}
            </p>
            <p class="tab-content-cell">
              {{ item ? item.lastLogin : '--' }}
            </p>
            <p class="tab-content-cell tab-content-cell-green">
              <template v-if="item">
                            <span v-if="item.mobile"
                                  @click="gotoWsapp(getUrl(item.mobile))"
                                  class="green" style="cursor: pointer; text-decoration: underline;">
                                Private Message
                            </span>
                <span v-else class="gray">Private Message</span>
              </template>
              <span v-else>--</span>
            </p>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.tab-wrapper {
  display: flex;
  gap: .2rem;
  margin-top: 10rem;
}
.tab-content {
  display: flex;
}
.tab-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
}
.tab-item-act {
  width: 20.4rem;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("@/assets/myreferral/button_active.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
}

.tab-item {
  width: 20.4rem;
  height: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url("@/assets/myreferral/button.png");
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: contain;
}
.btm {
  height:2.4rem;
  width: auto;
}

.my-affiliate-contain {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.title {
  padding: 1rem 3rem;
}

.content {
  width: 128rem;
  height: 60rem;
  overflow: auto;
  background-image: url("@/assets/iv_empty.png");
  background-repeat: no-repeat;
  background-size: auto;
  background-position: center;
}

.tab-header {
  display: table;
  width: 100%;
  background-image: url("@/assets/bg_commission_title.png");
  background-repeat: no-repeat;
  background-size: cover;
  table-layout: fixed;
  height: 6rem;
  position: sticky;
  top: 0;
}

.tab-header-row {
  display: table-row;
}

.tab-header-cell {
  display: table-cell;
  color: #FFE0BD;
  line-height: 6rem;
  text-align: center;
  font-size: 2rem;
}

.tab-content {
  display: table;
  width: 100%;
  table-layout: fixed;
  height: 6rem;

}

.tab-content-row {
  display: table-row;
  background: #4F20A8;
}

.tab-content-cell {
  display: table-cell;
  color: white;
  line-height: 6rem;
  text-align: center;
  font-size: 2rem;
}

.tab-content-cell-green {
  color: #31FF61;
}

.tab-content-cell-gold {
  color: #FBEB6E;
}

.tab-row-color {
  background: #4413A0;
}
</style>
